import { render, staticRenderFns } from "./GuestBoxExt.vue?vue&type=template&id=01d151e5&scoped=true&"
import script from "./GuestBoxExt.vue?vue&type=script&lang=js&"
export * from "./GuestBoxExt.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxExt.vue?vue&type=style&index=0&id=01d151e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d151e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d151e5')) {
      api.createRecord('01d151e5', component.options)
    } else {
      api.reload('01d151e5', component.options)
    }
    module.hot.accept("./GuestBoxExt.vue?vue&type=template&id=01d151e5&scoped=true&", function () {
      api.rerender('01d151e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s2vMko5176rw/JS/comp/GuestBoxExt.vue"
export default component.exports